import { Editor, Node, Transforms } from "slate";

export const clearAndResetEditor = (editor: Editor): void => {
  try {
    // Select all content and delete it
    if (editor.children && editor.children.length > 0) {
      const hasContent = Node.string(editor).length > 0;

      if (hasContent) {
        // Select all content and delete it
        Transforms.select(editor, {
          anchor: Editor.start(editor, []),
          focus: Editor.end(editor, []),
        });
        Transforms.delete(editor);
      }
    }

    // Ensure we have at least one empty paragraph
    if (!editor.children || editor.children.length === 0 || Node.string(editor) === "") {
      editor.children = [
        {
          children: [{ text: "" }],
        },
      ];
    }
  } catch (error) {
    console.warn("Error clearing editor content, reinitializing:", error);
    // Fallback: directly set the children to initial state
    editor.children = [
      {
        children: [{ text: "" }],
      },
    ];
  }
};
